import {uuid} from "../../util";

export default {
    document_db_id: null,
    document_url_id: null,
    entity_id: null,
    user: {},
    name: 'Title this Priorities board…',
    description: 'Move the idea cards on the Priorities board.',
    entity_name: 'Priorities Matrix',
    entity_group: 'Priorities Matrix',

    x_axis: 'Effort',
    y_axis: 'User Value',

    backlog: {
        tasks: []
    },

    high_effort_high_value: {
        tasks: []
    },
    low_effort_high_value: {
        tasks: []
    },
    high_effort_low_value: {
        tasks: []
    },
    low_effort_low_value: {
        tasks: []
    },


    team_id: null,
    team_shared: false,
}
